import React from 'react'

import SpinnerDiv from "./SpinnerDiv";
import Dropdown from "./ReactDropdown";

export default class DropdownProgressLevel extends Dropdown
{		
	
	// Entry properties
	//
	// mode : 'list' - Just act like a dropdown with each role itemised
	//        'filter' - act as a drop down filter list, including an 'ALL' option
	
	static get defaultProps() 
	{
		var v = 
	    {
		      mode: 'list', 
	    	  label: 'Select a value' ,
	    	  defaultValue: '#' 
		}

		return v;
	}
	
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 1 ;

		this.isDirty = this.isDirty.bind(this) ;
		this.setDirty = this.setDirty.bind(this) ;

		let v = 0 ;

		if ( this.props.defaultValue != null )
		{
			// We have reduced the number of values from 2 to 4, so just translate them for now
			v = this.translateLegacyValues(this.props.defaultValue);
		}

    	// Create a state item here
		this.state = { dirty: false ,currentValue: v, items: null };
		
	}

	translateLegacyValues ( id )
	{
		let translatedValue = id ;

		if ( id == 2 )
		{
			translatedValue = 1 ;
		}

		return translatedValue ;
	}

	UNSAFE_componentWillMount()
	{		
		// This is a callback to tell the parent our ID so it can talk to this contrao
		if ( this.props.parentRef != null )
		{
			this.props.parentRef ( this.props.id, this ) ;		
		}
		
		// Fetch the list of types to populste the dropdown
		this.getdata () ;
	}
	
	getdata( )
	{
		var items = [
		{
			id: '#',
			desc: 'Please select a response'
		},			  
		{
			id: '1',
			desc: 'Yes'
		},
		{
			id: '3',
			desc: 'Yes - Better than expected'
		},
		{
			id: '4',
			desc: 'No'
		}
		];
				
		this.setState ( { items : items } ) ;
	}
	
	/**
	* Returns true if the input value complies with the validation rules supplied
	* 
	* @param {string} param - The value of the string to be tested.
	* @return {bool} true if the test passes.
	*/
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == 0 || param == -1 || param == '#')
				{
					if ( this.state.items == null )
					{
						return true ;
					}
					else
					{
						if ( this.state.items.length > 0)
						{
							return false ;						
						}
						else
						{
							return true ;
						}
					}
				}
			}
			else
			{
				if ( param == null || param == 0)
				{
					// If not required, and empty, it's OK
					return true ;
				}
			}			
		}

		return true ;
	}
	/**
	* Externally callable function to test if the input field is valid
	* 
	* @return {bool} True if the field is valid.
	*/
	isValid()
	{		
		return this.isValueValid ( this.getValue() ) ;
	}
	
		/**
	* Externally callable function to test if the input field is valid
	* 
	* @return {bool} True if the field is valid.
	*/
	isDirty()
	{		
		return this.state.dirty ;
	}

	setDirty ( value )
	{
		this.setState ({dirty: value}) ;
	}

    sendChangeNotification()
    {
        if ( this.state.dirty == false )
        {
            if ( this.props.onDirty != null )
            {
                // Send a dirty notification if required, and only the first time we change
                this.props.onDirty() ;
            }
        }
    }

	handleChange(e) 
	{
		var targetName = e.target.name ;
		var val = e.target.value ;
		var index = e.target.selectedIndex;

		// Need to calculate the offset to read the actual Type Id from the correct place in the table
		// If it is a 'filter' then there is an extra entry in the listbox called 'ALL' which we need to account for
		
		var offset = 0 ;
		
		if ( this.props.mode == 'filter')
		{
			var offset = -1 ;
		}

		if ( index >= 0 )
		{
			var itemid = this.state.items[index+offset].id;			
			var itemtext = this.state.items[index+offset].desc ;

            this.sendChangeNotification() ;

            this.setState ( {dirty: true, currentValue: itemid} ) ;
		}
		else
		{
			var itemid = 0 ;		
			var itemtext = "All" ;

            this.sendChangeNotification() ;

            this.setState ( {dirty: true, currentValue: itemid} ) ;
		}
		
		// Tell the owning function about the change	
		
		if ( this.props.callback != null )
		{
			this.props.callback ( itemtext ) ;		
		}
		
	}
	  
    getValue()
    {
    	return this.state.currentValue ;
    }
    
    optionList ()
    {
        var lineList=[];
        
        // This element renders from the list of user types returned by the getdata() ajax function above
    	var itemArray = this.state.items ;

    	if ( itemArray != null )
        {
        	var i = 0 ;
            var len = itemArray.length;
            var row = null ;
            var typeId = null ;
            var typeText = null ;
            
            // If it's a filter list, add the 'ALL' option
                		
            for (i=0; i<len; ++i) 
            {
            	if (i in itemArray) 
            	{
            		row = itemArray[i];
            		
            		typeId = row.id ;
            		typeText = row.desc;
            		
            		lineList.push(React.createElement ( 'option', {key: this.keyCount++, name: typeId, value: typeId} , typeText));        			
            	}
            }
        }
        
        return lineList ;
    }
    
    dropdown_select ( id )
    {
    	return React.createElement ( 'select', {key: this.keyCount++, value: this.state.currentValue, className: 'form-control', id: id , tabIndex: this.props.tabIndex, onChange: this.handleChange.bind(this)}, this.optionList() ) ;
    }
    
    
    optionDropdown(id)
    {
    	var lineList=[];
    	
        lineList.push (React.createElement('label', {  key: this.keyCount++, htmlFor: this.props.id, className: 'col-form-label'}, this.props.label ));
    	lineList.push( this.dropdown_select(id));
    	
        if ( this.props.displayErrors == true )
    	{
            lineList.push ( this.errorDiv(true) ) ;    	
    	}
    	
    	
    	return lineList ;
    }
  
    render() 
    {
    	this.keyCount = 0 ;

		if ( this.props.readOnly !== 'readonly' )
		{
			return React.createElement ( 'div', {key: this.keyCount++, className: 'input-group'}, this.optionDropdown('list1')) ;
		}
		else
		{
			return React.createElement ( 'div', {key: this.keyCount++}, this.readOnlyField()) ;
		}
    }
};


